import React, { useState, useContext, useEffect } from "react";
import DocumentMeta from "react-document-meta";
import axios from "axios";
import Config from "../config.json";
import jobsOpportunitiesPic from "../Images/jobsOpportunitiesPic.webp";
import ComponentContext from "../Context";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | فرصت‌های شغلی",
  meta: {
    charset: "utf-8",
    name: { keywords: "پژوهیار" },
  },
};
const JobsOpportunities = () => {
  const [jobsOpportunities, setJobsOpportunities] = useState([]);
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    description: "",
    jobPosition: "",
  });
  const [jobDescription, setJobDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [errors, setErrors] = useState({
    fullname: "",
    phone: "",
    email: "",
    jobPosition: "",
    file: "",
  });
  const context = useContext(ComponentContext);

  const [loadingJobs, setLoadingJobs] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const stored = sessionStorage.getItem("jobsOpportunities");
    if (stored) {
      setJobsOpportunities(JSON.parse(stored));
      setLoadingJobs(false);
    } else {
      axios
        .get(`${Config.url}/job-posts`)
        .then(res => {
          const list = res.data.data;
          setJobsOpportunities(list);
          sessionStorage.setItem("jobsOpportunities", JSON.stringify(list));
        })
        .catch(err => {
          console.error("خطا در دریافت لیست:", err);
        })
        .finally(() => {
          setLoadingJobs(false);
        });
    }
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(fd => ({ ...fd, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));

    if (name === "jobPosition") {
      const job = jobsOpportunities.find(j => j.id.toString() === value);
      setJobDescription(job?.description || "");
    }
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setErrors(prev => ({ ...prev, file: "" }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (!formData.fullname.trim()) {
      newErrors.fullname = "نام و نام خانوادگی الزامی است";
      isValid = false;
    }

    const phoneRegex = /^09\d{9}$/;
    if (!formData.phone) {
      newErrors.phone = "شماره تلفن الزامی است";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "شماره تلفن معتبر نیست (09xxxxxxxxx)";
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "ایمیل الزامی است";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "ایمیل معتبر نیست";
      isValid = false;
    }

    if (!formData.jobPosition) {
      newErrors.jobPosition = "انتخاب موقعیت شغلی الزامی است";
      isValid = false;
    }

    if (!selectedFile) {
      newErrors.file = "بارگذاری رزومه الزامی است";
      isValid = false;
    } else if (selectedFile.type !== "application/pdf") {
      newErrors.file = "فایل باید با فرمت PDF باشد";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    const data = new FormData();
    Object.entries(formData).forEach(([k, v]) => data.append(k, v));
    data.append("jobs", formData.jobPosition);
    data.append("file", selectedFile);

    axios
      .post(`${Config.url}/jobs`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        context.notification("رزومه شما با موفقیت ارسال شد", "success");
        setFormData({
          fullname: "",
          phone: "",
          email: "",
          description: "",
          jobPosition: "",
        });
        setJobDescription("");
        setSelectedFile(null);
        setErrors({
          fullname: "",
          phone: "",
          email: "",
          jobPosition: "",
          file: "",
        });
      })
      .catch(err => {
        console.error(err);
        context.notification("ارسال پیام با خطا مواجه شد", "error");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample">
        <div className="hero-sample-right ">
          <h1>فرصت‌های شغلی</h1>
          <p className="text-justify">
            اگر مایلید که در محیطی حرفه‌ای، پویا و صمیمی رشد کنید و به رشد
            دیگران کمک کنید، و در ساختن محصولات دانش‌بنیان با اثرگذاری بالا سهیم
            باشید، با ما همراه شوید.
          </p>
        </div>
        <div className="hero-sample-left hero-job-left">
          <img src={jobsOpportunitiesPic} alt="فرصت‌های شغلی" />
        </div>
      </section>

      <div className="container mb-5 d-flex justify-content-center">
        <div className="resume-card">
          <h2 className="resume-card-title">ارسال رزومه</h2>

          <form onSubmit={handleSubmit} noValidate>
            <div className="row">
            <div className="col-md-4 form-group">
              <label>انتخاب موقعیت شغلی</label>
              {loadingJobs ? (
                <div className="d-flex align-items-center">
                  <div
                    className="spinner-border spinner-border-sm ml-2"
                    role="status"
                  />
                  <span>در حال بارگذاری فرصت‌های شغلی...</span>
                </div>
              ) : (
                <select
                  name="jobPosition"
                  className={`form-control ${
                    errors.jobPosition && "is-invalid"
                  }`}
                  value={formData.jobPosition}
                  onChange={handleChange}
                  required>
                  <option value="">– لطفاً انتخاب کنید –</option>
                  {jobsOpportunities.map(pos => (
                    <option key={pos.id} value={pos.id}>
                      {pos.title}
                    </option>
                  ))}
                </select>
              )}
              {errors.jobPosition && (
                <div className="invalid-feedback">{errors.jobPosition}</div>
              )}
            </div>

            <div className="col-md-8 form-group">
              <label>توضیحات مربوط به موقعیت شغلی</label>
              <p className="job-desc">{jobDescription}</p>
            </div>
            </div>
            <div className="row">
              <div className="col-md-4 form-group">
                <label>نام و نام خانوادگی</label>
                <input
                  type="text"
                  name="fullname"
                  className={`form-control ${errors.fullname && "is-invalid"}`}
                  value={formData.fullname}
                  onChange={handleChange}
                  required
                />
                {errors.fullname && (
                  <div className="invalid-feedback">{errors.fullname}</div>
                )}
              </div>

              <div className="col-md-4 form-group">
                <label>شماره تلفن</label>
                <input
                  type="tel"
                  name="phone"
                  className={`form-control ${errors.phone && "is-invalid"}`}
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && (
                  <div className="invalid-feedback">{errors.phone}</div>
                )}
              </div>

              <div className="col-md-4 form-group">
                <label>ایمیل</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control ${errors.email && "is-invalid"}`}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
            </div>

            

            <div className="form-group">
              <label>توضیحات شما</label>
              <textarea
                name="description"
                className="form-control"
                rows="4"
                placeholder="در صورت نیاز توضیح دهید..."
                value={formData.description}
                onChange={handleChange}
              />
            </div>

            <div className="form-group col-md-6">
              <label>بارگذاری رزومه (PDF)</label>
              <input
                type="file"
                name="resume"
                className={`form-control-file custom-file-upload ${
                  errors.file && "is-invalid"
                }`}
                onChange={handleFileChange}
                accept="application/pdf"
              />
              {errors.file && (
                <div className="invalid-feedback d-block">{errors.file}</div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-submit"
              disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm ml-2"
                    role="status"
                    aria-hidden="true"
                  />
                  در حال ارسال...
                </>
              ) : (
                "ارسال رزومه"
              )}
            </button>
          </form>
        </div>
      </div>
    </DocumentMeta>
  );
};

export default JobsOpportunities;
